var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoChevronUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.18651 12.8125C1.06216 12.6875 0.999994 12.5 0.999994 12.25C0.999994 12 1.06216 11.8125 1.18651 11.6875C6.59587 6.74997 9.3316 4.25 9.39378 4.1875C9.51813 4.0625 9.70465 4 9.95336 4C10.2021 4 10.3886 4.0625 10.5129 4.1875L18.7202 11.6875C19.0933 12.0625 19.0933 12.4375 18.7202 12.8125C18.3471 13.1875 17.9741 13.1875 17.601 12.8125L10.6995 6.53125C10.6995 6.53125 10.1898 6 9.95336 6C9.71693 6 9.20725 6.53125 9.20725 6.53125L2.30568 12.8125C1.93263 13.1875 1.55957 13.1875 1.18651 12.8125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChevronUp);
export default __webpack_public_path__ + "static/media/ico_chevron_up.00ac792073856bc0654a7b3ac67eda1e.svg";
export { ForwardRef as ReactComponent };